import { css } from '@emotion/core'
import { Link as GatsbyLink } from 'gatsby'
import * as React from 'react'

import { breakpoints } from '../constants/breakPoints'
import Arrow from '../icons/abstract/arrow.svg'

declare let window: Window & {
  analytics?: {
    page: () => void
  }
  Intercom?: any
}

interface Props extends React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement> {
  withArrow?: boolean
  withUnderline?: boolean
  arrowColor?: string
}

export const Link: React.FunctionComponent<Props> = ({
  href,
  onClick,
  withArrow = false,
  withUnderline = false,
  arrowColor = '#318eff',
  children,
  className,
  ...other
}) => {
  const onClickIntercept = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    if (!!window.Intercom) {
      window.Intercom('hide')
    }

    if (onClick) {
      onClick(event)
    }
  }

  if (href && href.match(/^\//) && !href.match(/^\/\//) && !href.match(/\.(pdf)$/)) {
    return (
      <GatsbyLink
        to={href}
        onClick={onClickIntercept}
        className={className}
        css={(withArrow || withUnderline) && linkStyle(withUnderline, className)}
        {...(other as any)}
      >
        {children}
        {withArrow && <Arrow css={arrowStyle(arrowColor, className)} />}
      </GatsbyLink>
    )
  } else if (href && href.match(/^\//)) {
    return (
      <a
        href={href}
        rel="noopener"
        onClick={onClickIntercept}
        className={className}
        css={withArrow && linkStyle(withUnderline, className)}
        {...other}
      >
        <>
          {children}
          {withArrow && <Arrow css={arrowStyle(arrowColor, className)} />}
        </>
      </a>
    )
  } else {
    return (
      <a
        href={href}
        rel="noreferrer"
        target="_blank"
        onClick={onClickIntercept}
        className={className}
        css={withArrow && linkStyle(withUnderline, className)}
        {...other}
      >
        <>
          {children}
          {withArrow && <Arrow css={arrowStyle(arrowColor, className)} />}
        </>
      </a>
    )
  }
}

const linkStyle = (withUnderline: boolean, className?: string) => css`
  ${withUnderline && 'text-decoration: underline'};

  &:hover {
    opacity: 0.65;
    & > * {
      transform: ${className?.includes('body-1')
        ? 'translateX(0.5rem) translateY(1px) scale(0.8)'
        : className?.includes('strong-body-2')
        ? 'translateX(0.4rem) translateY(1.4px) scale(0.7)'
        : 'translateX(0.5rem)'};
    }
  }
`

const arrowStyle = (arrowColor?: string, className?: string) => css`
  margin-left: ${className?.includes('body-1')
    ? '0.25rem'
    : className?.includes('strong-body-2')
    ? '0.15rem'
    : '0.5rem'};

  transition: all 0.1s ease-out;

  transform: ${className?.includes('body-1')
    ? 'scale(0.8) translateY(1px)'
    : className?.includes('strong-body-2')
    ? 'scale(0.7) translateY(2px)'
    : 'none'};

  ${arrowColor &&
  `
  path {
    stroke: ${arrowColor};
  }`};

  @media screen and (max-width: ${breakpoints.medium}px) {
    ${!className?.includes('body-1') &&
    !className?.includes('strong-body-2') &&
    `
      margin-left: 0.25rem;
      transform: scale(0.8) translateY(1px);
    `};
  }
`
